import React, { Component } from 'react';
import { getFaq, search } from '../webAPI/faqService';
import FAQ from './FAQ';

class FAQContainer extends Component {
	constructor(props) {
		super(props);

		this.state = {
			showFaq: false,
			terms: '',
			results: [],
			topics: [],
			question: {},
			answer: {}
		};

		this.handleHelpButtonClick = this.handleHelpButtonClick.bind(this);
		this.fetchFAQ = this.fetchFAQ.bind(this);
		this.handleSearchChange = this.handleSearchChange.bind(this);
		this.handleQuestionClick = this.handleQuestionClick.bind(this);
		this.handlePreviousClick = this.handlePreviousClick.bind(this);
	}

	componentDidMount() {
		this.fetchFAQ();
	}

	render() {
		if (__COM__) return null;

		return (
			<FAQ
				showFaq={this.state.showFaq}
				terms={this.state.terms}
				results={this.state.results}
				topics={this.state.topics}
				question={this.state.question}
				answer={this.state.answer}
				onHelpButtonClick={this.handleHelpButtonClick}
				onSearchChange={this.handleSearchChange}
				onQuestionClick={this.handleQuestionClick}
				onPreviousClick={this.handlePreviousClick}
			/>
		);
	}

	handleHelpButtonClick() {
		this.setState({
			showFaq: !this.state.showFaq
		});
	}

	fetchFAQ() {
		getFaq().then(
			error => null,
			result =>
				this.setState({
					topics: result.topics || []
				})
		);
	}

	handleSearchChange(event) {
		const terms = event.target.value;
		search(terms).then(
			error => null,
			result => {
				const results = result.topics;
				this.setState({
					results
				});
			}
		);
		this.setState({ terms });
	}

	handleQuestionClick(question) {
		this.setState({
			question,
			answer: question.answer
		});
	}

	handlePreviousClick() {
		this.setState({
			question: {},
			answer: {}
		});
	}
}

export default FAQContainer;



// WEBPACK FOOTER //
// ./src/js/faq/FAQContainer.js